export default __webpack_public_path__ + "static/media/line-logo.0178bc75.svg";